import type { Theme } from '@mui/material/styles';

/** The field content area's padding (theme spacing units) — see FieldLayout. */
export const FIELD_PAGE_PADDING = 2;

/**
 * How wide a field page may get before it stops growing and centres (px).
 *
 * Sized for the Zeiterfassung grid on a tablet: its columns need ~765px to show
 * without scrolling sideways. A page whose content reads better narrow should
 * cap ITSELF rather than lowering this (see FIELD_STEPPER_MAX_WIDTH).
 */
export const FIELD_PAGE_MAX_WIDTH = 900;

/**
 * Full-bleed on phones: cancels the field page padding with a negative margin
 * so a child — in practice a DataGrid — meets the screen edges, and drops its
 * outline and rounded corners. From `sm` up the page keeps its padding and the
 * child its normal boxed look.
 *
 * Spread into a component's `sx` theme callback; the grid it wraps needs
 * `fieldFullBleedGridSx` for the border half.
 */
export function fieldFullBleedSx(theme: Theme) {
    return {
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(-FIELD_PAGE_PADDING),
            marginRight: theme.spacing(-FIELD_PAGE_PADDING)
        }
    };
}

/** The border/corner half of the full-bleed look, for the DataGrid's own `sx`. */
export function fieldFullBleedGridSx(theme: Theme) {
    return {
        [theme.breakpoints.down('sm')]: {
            border: 0,
            borderRadius: 0
        }
    };
}
